/**
 * Created by yoavp on 12/15/2014.
 */
/**
 * Created by yoavp on 11/18/2014.
 */
define(function(require){
    "use strict";

    var LE = require("app");
    var Template = require("connection-templates/KPsTab/profile.tmpl");

    var ProfileView;
    LE.module('LEConnection', function (LEConnection, LE, Backbone, Marionette, $, _) {
        ProfileView = Marionette.ItemView.extend({
            template: Template,
            className: 'cp-profile-container',

            ui: {
                "closeMainContainer": ".cp-close-wrapper"
            },

            events: {
                "click .cp-close-wrapper": "_closeMainContainer" // how should I use ui?
            },

            initialize: function (options) {

            },

            _closeMainContainer: function() {
                LEConnection.vent.trigger("ConnectionPanelLayoutController:closeConnectionPanel");
            }




        });
    });

    return ProfileView;


});